export const contactCardContent = [
  {
    name: "Yuca Waarts",
    organisation: null,
    email: "yuca@agri-logic.nl",
  },
  {
    name: "Vaibhav Panpaliya",
    organisation: "IDH",
    email: "panpaliya@idhtrade.org",
  },
  {
    name: "Antonie Fountain",
    organisation: "Voice Network",
    email: "antonie@voicenetwork.cc",
  },
  {
    name: "Valerie Janssen",
    organisation: "WUR",
    email: "valerie1.janssen@wur.nl",
  },
];
